import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography, Grid, Card, FormControlLabel } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import StartCalendar from '../DatePicker/startCalendar';
import CustomPoper from '../../CustomizedUIs/CustomPoperCalendar';
import colors from '../../CustomizedUIs/Colors';
import moment from 'moment-timezone';
import TimePicker from '../../common/TimePicker'


const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: colors.white['50'],
    borderWidth: 1,
    borderColor: colors.lightBlue['200'],
    borderRadius: 4
  },
  card: {
    marginTop: theme.spacing(1),
    borderRadius: 0,
    width: 207,
    height: 36,
    boxShadow: 'unset'
  },
  titleRadio: {
    fontFamily: "UniviaPro-Medium",
    fontSize: 11,
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
  },
  titleDateTime: {
    fontFamily: "UniviaPro",
    fontSize: 11,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.36,
    letterSpacing: "normal",
    color: "#88898c",
  },
  TextDateTime: {
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.85,
    letterSpacing: " 0.13px",
    color: "#4f5064",
  },
}));

const formatTime = (times) => {
  if (!times) {
    return '';
  }
  return moment(times).format('HH:mm:ss');
};

let oldDate = null;
function DateTimePicker({ open, date, setDate, style, title, minDate }) {
  const classes = useStyles();
  const translate = useTranslate();
  const [openTimePickerStart, setOpenTimePickerStart] = useState(false)
  // STATE REGION
  const [openPoper, setOpenPopper] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  // END STATE REGION

  const onOpenCalendar = (event) => {
    setAnchorEl(event.currentTarget);
    oldDate = date;
  }

  const onCloseCalendar = (event) => {
    setAnchorEl(null);
    setDate(oldDate);
  }

  const onChangeDate = (date) => {
    setDate(date);
    onFinishPickDate(date)
  }

  const onFinishPickDate = (date) => {
    setAnchorEl(null);
    setDate(date);
    oldDate = null;
  }
  if (!open) return null;
  return (
    <Box className={classes.container}>
      <Box mx={2} width='100%' >
        {
          style &&
          <Typography style={{ marginTop: '10px' }} className={classes.titleRadio}>{style === 'alarm' ? translate(`resources.alarm.Dateandtime`) : style === 'calendar'? translate(`resources.alarm.DateandtimeCalendar`) : translate(`resources.messages.Dateandtime`)}</Typography>
        }
        <Grid style={{ marginTop: '11px' }} container justify="space-between" alignItems="flex-end">
          <Grid item style={{ width: style ? '450px' : '500px' }}>
            <StartCalendar
              minDate={minDate}
              anchorEl={anchorEl}
              handleClick={onOpenCalendar}
              handleClose={onCloseCalendar}
              handleDateChange={onChangeDate}
              finishPickDate={onFinishPickDate}
              value={moment(date).format('YYYY-MM-DD')}
              date={date}
              Title={title}
            />
          </Grid>
          <Grid item>
            <CustomPoper
              isNotInfoPage={true}
              open={openPoper}
              anchorEl={anchorEl}
              handleClick={() => setOpenPopper(true)}
              handleClose={() => setOpenPopper(false)}
              title={translate(`pos.messages.calendar`)}
              content={translate(`pos.messages.constentCalendar`)}
              icon={<b>?</b>}
            />
          </Grid>
        </Grid>{

        }
        <Card className={classes.card}>
          <FormControlLabel
            classes={{ label: classes.titleDateTime }}
            control={
              <Box style={{ color: "black" }} ml={2} display="flex">
                <Typography onClick={() => setOpenTimePickerStart(true)} className={classes.TextDateTime}>{formatTime(date)}</Typography>
              </Box>
            }
            label={translate(`resources.severlog.Time`)}
            style={{ marginTop: "8px", color: "#88898c" }}
            labelPlacement="start"
            variant="body2"
          />
          <TimePicker
            openTimePicker={openTimePickerStart}
            handleClick={onOpenCalendar}
            setOpenTimePicker={setOpenTimePickerStart}
            handleDateChange={onChangeDate}
            finishPickDate={onFinishPickDate}
            value={moment(date).format('YYYY-MM-DD')}
            date={date}

          />
        </Card>
      </Box>
    </Box>
  )
}

DateTimePicker.propTypes = {
  open: PropTypes.bool.isRequired,
  date: PropTypes.object.isRequired,
  setDate: PropTypes.func.isRequired,
};

export default DateTimePicker;
